export default __webpack_public_path__ + "static/media/navbar-api-orange.1ca1467c.svg";